export default __webpack_public_path__ + "static/media/graf_gradetion20.026eaeb8.png";